import React, { Fragment, useContext } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import moment from "moment";
import { Row, Col, Tag, Button, Text } from "../../common/UIComponents";
import { isEmpty } from "../../common/Common";
import I18n from "../../common/I18n";
import FilterTag from "./FilterTag";
import { selectedWarehouseNames } from "../../helpers/common";
import { limitString } from "../../helpers/common";
import AppConfig from "../../config/AppConfig";
import EndUserTitle from "../common/EndUserTitle";
import { OrderConfigContext } from "../../context/OrderConfigContext";
import { fetchFilteredUser } from "../../api/UsersApi";
import { getLabellFromOrderType } from "../../helpers/orders";
import { TagCloseIcon } from "../../common/CustomIcon";
import { OrgContext } from "../../context/OrgContext";
import * as ServiceLevelsApi from "../../api/ServiceLevels";

const AppliedFilters = (props) => {
  const {
    filterPlaceHolder,
    handleOnFilterElementChange,
    currentAccount,
    filter,
    currentWarehouse,
    handleOnOrderTokenClose,
    clearFilter,
    handleOnFilterChange,
    accounts,
    warehouseFilter,
    execode,
    isShipper,
    softClearFilter,
    usersData= [],
    isAirCargo = () => {},
    // isSearching = false,
    // isPending = false,
    hideDateFilter = false,
    currentUIVersion = 'v1',
  } = props;

  const [ filteredWhs, setFilteredWhs ] = React.useState(selectedWarehouseNames(warehouseFilter));
  const { orderConfig: { orderTypeKeysForFilter = {}, enhancedOrderTypes = [] } = {}, omtByOrderLabel = {} } = useContext(OrderConfigContext);
  const { currentOrg } = useContext(OrgContext);

  // Mode A: id -> name map for the "Service Level" chip. Fetched once, and only
  // when a service-level filter is actually applied.
  const [ slNames, setSlNames ] = React.useState({});
  const slIds = filterPlaceHolder?.service_level_ids || [];
  React.useEffect(() => {
    if (slIds.length === 0 || Object.keys(slNames).length > 0) return;
    ServiceLevelsApi.catalog({ orgId: currentOrg?.id }).then((res) => {
      if (!res.success) return;
      const map = {};
      (res.data || []).forEach((mt) => (mt.service_levels || []).forEach((sl) => { map[sl.id] = sl.name; }));
      setSlNames(map);
    });
  }, [slIds.length]);
  //const isAirCargoOrg = isAirCargo()

  const CustomCloseIcon = ({ onClose }) => (
    <TagCloseIcon
      style={{
        position: "absolute",
        top: "5px",
        right: "5px",
        cursor: "pointer",
        fontSize: "16px",
        color: "#576ec1", // Custom color for the close icon
      }}
      onClick={onClose}
    />
  );


  React.useEffect(() => {
    setFilteredWhs(selectedWarehouseNames(warehouseFilter));
  }, [ warehouseFilter ]);

  const formatString = (value) => {
    if (!value) return "";
    return value
      .split("_")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const getInsertionTypeLabel = (values) => {
    if (Array.isArray(values)) {
      return values.map(value => {
        switch (value) {
          case "API":
            return "EDI";
          case "M":
            return "MANUAL";
          case "S":
            return "SFTP";
          case "PDF":
            return "PDF";  
          case "U":
            return "UPLOADED";
          case "EMAIL":
            return "EMAIL";
          case "Q":
            return "QUOTE";     
          default:
            return "";
        }
      }).join(", ");
    } else {
      return "";
    }
  };

  // Extracted as a SearchResultsRow Component for better readability and reusability
  const SearchResultsRow = ({ search_key_type, search_type, filterPlaceHolder, handleOnOrderTokenClose, softClearFilter }) => {
    const tokens = _.uniq(_.split(filterPlaceHolder.search_key_value, ",")).filter(token => !isEmpty(token));
    const isFullSearch = search_type !== "contains" ;
      const { endUserName } = useContext(OrgContext);
    const renameKeyData = {
      "customer_order_number" : "ORDER NUMBER",
      "hawb" : "HAWB",
      "mawb" : "MAWB",
      "reference_1" : "REFERENCE 1",
      "reference_2" : "REFERENCE 2",
      "customer first name" : `${endUserName} ${I18n.t("order.filters.name_suffix")}`
    }
    const searchLabelText = search_type !== "contains" ? <Text>
      Results for <Text strong>Orders</Text> :&nbsp;
    </Text>
      : <Text>
        Results for <Text strong>{ renameKeyData[ search_key_type ] || search_key_type.toUpperCase() }</Text> which <Text strong>{ search_type }</Text> :&nbsp;
      </Text>;

    return (
      <Row className="marginBottom10">
        <Col xs={ 24 }>
          { searchLabelText }
          {isFullSearch ?
           tokens.map(token => (
            <Tag
              className="filteredTagStyle"
              closable
              onClose={ () => handleOnOrderTokenClose(token) }
              key={ `tags${token}` }
            >
              { _.trim(token, " ") }
            </Tag>
          )) :
          <Tag className="filteredTagStyle">
            { filterPlaceHolder.search_key_value }
          </Tag>
          }
          <Button data-testid="clear-search-button" size="small" type="default" onClick={ softClearFilter }>
            Clear Search
          </Button>
        </Col>
      </Row>
    );
  };

  return (
    <Fragment>
      { (!isEmpty(filterPlaceHolder.search_key_value)) ?
        (<SearchResultsRow
          search_key_type={!isEmpty(filterPlaceHolder.search_key_type) &&  filterPlaceHolder.search_type === "CONTAINS"  ? filterPlaceHolder.search_key_type.split("_").join(" ") : ""}
          search_type={ filterPlaceHolder.search_type === "CONTAINS" ? "contains" : "EQUALS" }
          filterPlaceHolder={ filterPlaceHolder }
          handleOnOrderTokenClose={ handleOnOrderTokenClose }
          softClearFilter={ softClearFilter }
        />)
        :
        <div>
        <Row className="marginBottom10">
          <Col xs={ 24 } className="textBold">
            <span className="body-2-large">Applied filters : &nbsp;</span>
            {/* <Fragment>
              { filter !== "" ? (
                <Tag
                  visible
                  color="blue"
                  closable={ false }
                  onClose={ () => handleOnFilterChange("filter", "") }
                  className="marginTop7"
                >
                  Status: { filter }
                </Tag>
              ) : (
                <Tag visible color="blue">
                  Status: ALL
                </Tag>
              ) }
            </Fragment> */}
            {/* &nbsp;&nbsp; */ }
            { !isEmpty(filterPlaceHolder.undelivered_orders) ? (
              <Fragment>
                <Tag
                  className="filteredTagStyle"
                  closable
                  onClose={ () => {
                    clearFilter()
                    // handleOnFilterElementChange("undelivered_orders", "none")
                   }
                  }
                >
                  {"Undelivered Orders"}
                  {/* {formatString(filterPlaceHolder.undelivered_orders)} */}
                </Tag>
                &nbsp;&nbsp;
              </Fragment>
            ) : (
              ""
            )}
            { !isEmpty(filterPlaceHolder.order_type)  && (
              <FilterTag
                InternationalizationText={I18n.t("order.type")}
                onClose={ () => handleOnFilterElementChange("order_type", "") }                
                filterValue={filterPlaceHolder.order_type}
                closable={ filterPlaceHolder.order_type === "" ? false : true}
              >
                {orderTypeKeysForFilter[filterPlaceHolder.order_type]}
              </FilterTag>
            ) }
            { !isEmpty(filterPlaceHolder.order_label) && (
              <FilterTag
                InternationalizationText={I18n.t("order.type")}
                onClose={ () => handleOnFilterElementChange("order_label", "") }                
                filterValue={filterPlaceHolder.order_label}
                closable={ filterPlaceHolder.order_label === "" ? false : true}
              >
                {/* Move-type orgs: the chip shows the org's alias for the label. */}
                {omtByOrderLabel[filterPlaceHolder.order_label]?.alias_name ||
                  getLabellFromOrderType( currentUIVersion ,enhancedOrderTypes, [filterPlaceHolder.order_label], true)}
              </FilterTag>
            ) }
            <FilterTag
              InternationalizationText={ I18n.t("general.accounts") }
              closable={!isShipper}
              onClose={ () => handleOnFilterElementChange("account_codes", []) }
              filterValue={ filterPlaceHolder?.account_codes }
            >
              {/* {currentAccount.name} */ }
              {
                limitString(filterPlaceHolder?.account_codes &&
                  accounts
                    .filter((acc) =>
                      filterPlaceHolder.account_codes.includes(acc.code)
                    )
                    .map((accName) => accName.name)
                    .join(", "), 5)
              }
            </FilterTag>
            {/* { filteredWhs.length > 0 && (
              <FilterTag
                InternationalizationText={ I18n.t("location.location") }
                // onClose={ () => warehouseFilter.onWarehouseChange("") }
                filterValue={ warehouseFilter.warehouses }
                closable={false} // warehouseFilter.warehouses.length > 1 ? true : false
              >
                { filteredWhs }
              </FilterTag>
            ) } */}

            {(() => {
              const whs = warehouseFilter?.warehouses || [];
              const warehouseName = (id) => (whs.find((wh) => wh.id === id) || {}).name || id;
              const originId = filterPlaceHolder.origin_wh_location_id;
              const destinationId = filterPlaceHolder.destination_wh_location_id;
              if (originId && destinationId) {
                return (
                  <FilterTag
                    InternationalizationText={"Origin → Destination"}
                    onClose={() => handleOnFilterElementChange("origin_destination", "")}
                    closable
                    filterValue={originId}
                  >
                    {`${warehouseName(originId)} → ${warehouseName(destinationId)}`}
                  </FilterTag>
                );
              }
              if (originId) {
                return (
                  <FilterTag
                    InternationalizationText={I18n.t("order.filters.sortBy.order_list_origin")}
                    onClose={() => handleOnFilterElementChange("origin_wh_location_id", "")}
                    closable
                    filterValue={originId}
                  >
                    {warehouseName(originId)}
                  </FilterTag>
                );
              }
              if (destinationId) {
                return (
                  <FilterTag
                    InternationalizationText={I18n.t("order.filters.sortBy.order_list_destination")}
                    onClose={() => handleOnFilterElementChange("destination_wh_location_id", "")}
                    closable
                    filterValue={destinationId}
                  >
                    {warehouseName(destinationId)}
                  </FilterTag>
                );
              }
              return null;
            })()}
            <FilterTag
              InternationalizationText={ I18n.t("general.zone") }
              onClose={ () => handleOnFilterElementChange("zone_ids", []) }
              closable
              filterValue={ filterPlaceHolder.zone_ids }
            >
              {
                limitString(filterPlaceHolder?.zone_ids &&
                  filterPlaceHolder.zone_ids.map((zone) => zone.label).join(", "), 5)
              }
            </FilterTag>
            { !hideDateFilter && !isEmpty(filterPlaceHolder) &&
              !isEmpty(filterPlaceHolder.fromDate) ? (
              <Fragment>
                <Tag
                  className="filteredTagStyle"
                  closable
                  onClose={ () =>
                    handleOnFilterElementChange("dateFilter", {
                      fromDate: null,
                      toDate: null,
                    })
                  }
                >
                  { I18n.t("general.scheduled") } { I18n.t("general.date") }: &nbsp;
                  { moment(filterPlaceHolder.fromDate).format("MMM DD YYYY") ===
                    moment(filterPlaceHolder.toDate).format("MMM DD YYYY") ? (
                    moment(filterPlaceHolder.fromDate).format("MMM DD YYYY")
                  ) : (
                    <Fragment>
                      { moment(filterPlaceHolder.fromDate).format("MMM DD YYYY") }
                      &nbsp;-&nbsp;
                      { moment(filterPlaceHolder.toDate).format("MMM DD YYYY") }
                    </Fragment>
                  ) }
                </Tag>
                &nbsp;&nbsp;
              </Fragment>
            ) : (
              ""
            ) }
            { !isEmpty(filterPlaceHolder.search_key_type) &&
              !isEmpty(filterPlaceHolder.search_key_value) ? (
              <Fragment>
                <Tag
                  className="filteredTagStyle"
                  closable
                  onClose={ () =>
                    handleOnFilterElementChange("search_key_type", {
                      search_key_type: "",
                      search_key_value: "",
                    })
                  }
                >
                  { I18n.t(`order.filters.${filterPlaceHolder.search_key_type}`) }:{ " " }
                  { filterPlaceHolder.search_key_value }
                </Tag>
                &nbsp;&nbsp;
              </Fragment>
            ) : (
              ""
            ) }
            { !isEmpty(
              filterPlaceHolder[ I18n.t("order.filters.schedule_orders.type") ]
            ) ? (
              <Fragment>
                { filterPlaceHolder[
                  I18n.t("order.filters.schedule_orders.type")
                ] !== I18n.t("order.filters.schedule_orders.both_key") ? (
                  <Tag
                    className="filteredTagStyle"
                    closable={false}
                    onClose={ () =>
                      handleOnFilterElementChange(
                        I18n.t("order.filters.schedule_orders.type"),
                        I18n.t("order.filters.schedule_orders.both_key")
                      )
                    }
                  >
                    { I18n.t("order.filters.schedule_orders.label") }:{ " " }
                    { I18n.t(
                      `order.filters.schedule_orders.${filterPlaceHolder[
                      I18n.t("order.filters.schedule_orders.type")
                      ]
                      }_label`
                    ) } &nbsp;
                        <CustomCloseIcon
                          onClose={() =>
                            handleOnFilterElementChange(
                              I18n.t("order.filters.schedule_orders.type"),
                              I18n.t("order.filters.schedule_orders.both_key")
                            )
                          }
                        />
                    
                  </Tag>
                ) : (
                  <Tag className="filteredTagStyle" visible>
                    { I18n.t("order.filters.schedule_orders.label") }:{ " " }
                    { I18n.t(
                      `order.filters.schedule_orders.${filterPlaceHolder[
                      I18n.t("order.filters.schedule_orders.type")
                      ]
                      }_label`
                    ) } &nbsp;
                  </Tag>
                ) }
                &nbsp;&nbsp;
              </Fragment>
            ) : (
              ""
            ) }
            { !isEmpty(filterPlaceHolder.vehicle_type) ? (
              <Fragment>
                <Tag
                  className="filteredTagStyle"
                  closable
                  onClose={ () =>
                    handleOnFilterElementChange("vehicle_type", "")
                  }
                >
                  { I18n.t("vehicleTypes.title") }:{ " " }
                  { filterPlaceHolder.vehicle_type }
                </Tag>
                &nbsp;&nbsp;
              </Fragment>
            ) : (
              ""
            )}
            {/* { filterPlaceHolder?.insertion_type?.length > 0 ? (
            <Fragment>
                <FilterTag
                  InternationalizationText={"Insertion Type"}
                  closable={ filterPlaceHolder.insertion_type.length > 0 }
                  onClose={ () => handleOnFilterElementChange("insertion_type") }
                  filterValue={ getInsertionTypeLabel(filterPlaceHolder?.insertion_type) }
                >
                  { getInsertionTypeLabel(filterPlaceHolder?.insertion_type) }
                </FilterTag>
                &nbsp;&nbsp;
            </Fragment>
          ) : null } */}
          { filterPlaceHolder?.created_by_ids && (_.compact(filterPlaceHolder.created_by_ids)).length > 0 ? (
            <Fragment>
                <FilterTag
                  InternationalizationText={ I18n.t("general.created_by") }
                  closable={ filterPlaceHolder.created_by_ids === "" ? false : true}
                  onClose={ () => handleOnFilterElementChange("created_by_ids") }
                  filterValue={ filterPlaceHolder.created_by_ids }
                >
                  {limitString(usersData.filter(user => filterPlaceHolder?.created_by_ids.includes(user.user_id)).map(user => user.user_name).join(", "),3)}
                </FilterTag>
                &nbsp;&nbsp;
            </Fragment>
          ) : (
            ""
          )}
          { slIds.length > 0 ? (
            <Fragment>
                <FilterTag
                  InternationalizationText={ I18n.t("order.service_level") }
                  closable
                  onClose={ () => handleOnFilterElementChange("service_level_ids", []) }
                  filterValue={ slIds }
                >
                  {limitString(slIds.map((id) => slNames[id] || id).join(", "), 3)}
                </FilterTag>
                &nbsp;&nbsp;
            </Fragment>
          ) : (
            ""
          )}
            { !isEmpty(filterPlaceHolder.sortBy) &&
              _.isString(
                I18n.t(`order.filters.sortBy.${filterPlaceHolder.sortBy}`)
              ) ? (
              <Fragment>
                {  !["none", "0"].includes(filterPlaceHolder.sortBy) ? (
                  <Tag
                    visible
                    className="filteredTagStyle"
                    closable={ filterPlaceHolder.sortBy !== "none" }
                    onClose={ () => handleOnFilterElementChange("sortBy", "none") }
                  >
                    { I18n.t("general.sort_by") }:{ " " }
                    { filterPlaceHolder.sortBy === 'consignee' ? <EndUserTitle/> : I18n.t(`order.filters.sortBy.${filterPlaceHolder.sortBy}`) }
                  </Tag>
                ) : (
                  <Tag className="filteredTagStyle" visible>
                    { I18n.t("general.sort_by") }:{ " " }
                    { I18n.t("order.filters.sortBy.none") }
                  </Tag>
                ) }
                &nbsp;&nbsp;
              </Fragment>
            ) : (
              ""
            ) }

            {props.isPending && ( !isEmpty(filterPlaceHolder.selectedSource) ? (
              <Fragment>
                <Tag
                  closable
                  className="filteredTagStyle"
                  onClose={() => handleOnFilterElementChange("selectedSource", "")}
                >
                  {I18n.t("general.source")}:{""}
                  {filterPlaceHolder.selectedSource}
                </Tag>
                &nbsp;&nbsp;
              </Fragment>
            ) : (
              <Tag visible  className="filteredTagStyle" >
                {I18n.t("general.source")}:{"All"}
              </Tag>
            ))}
          <Fragment>
            <FilterTag
              InternationalizationText={I18n.t('order.creation_source')}
              closable={filterPlaceHolder.insertion_type === "" ? false : true}
              onClose={() => handleOnFilterElementChange("insertion_type")}
              filterValue={filterPlaceHolder.insertion_type}
            >
              {(() => {
                const mapping = AppConfig.insertionTypes
                const getKeyFromValue = (value) => {
                  const match = mapping.find((item) => item.value === value);
                  return match ? match.key : value; 
                };

                if (Array.isArray(filterPlaceHolder.insertion_type)) {
                  return filterPlaceHolder.insertion_type
                    .map(getKeyFromValue)
                    .join(", ");
                } else {
                  return getKeyFromValue(filterPlaceHolder.insertion_type);
                }
              })()}
            </FilterTag>
            &nbsp;&nbsp;
          </Fragment>
           { !isEmpty(filterPlaceHolder.exclude_completed_orders) ? (
              <Fragment>
                <Tag
                  className="filteredTagStyle"
                  closable={
                      filterPlaceHolder?.exclude_completed_orders === true ||
                      filterPlaceHolder?.exclude_completed_orders === "true"
                        ? true
                        : false
                    }
                  onClose={ () =>
                    handleOnFilterElementChange("exclude_completed_orders", "")
                  }
                >
                  {I18n.t("order.filters.exclude_completed_order_lable")}:{ " " }
                  {filterPlaceHolder?.exclude_completed_orders === true ||
                    filterPlaceHolder?.exclude_completed_orders === "true"
                      ? "Yes"
                      : "No"}
                </Tag>
                &nbsp;&nbsp;
              </Fragment>
            ) : (
              ""
            )}
            { !isEmpty(filterPlaceHolder.is_imported) && (filterPlaceHolder.is_imported === true || filterPlaceHolder.is_imported === "true") ? (
              <Fragment>
                <Tag
                  className="filteredTagStyle"
                  closable={true}
                  onClose={ () =>
                    handleOnFilterElementChange("is_imported", false)
                  }
                >
                  {I18n.t("order.filters.imported_orders_lable")}:{ " " }
                  {"Yes"}
                </Tag>
                &nbsp;&nbsp;
              </Fragment>
            ) : (
              ""
            )}
            { !isEmpty(filterPlaceHolder.is_inbound) && (filterPlaceHolder.is_inbound === true || filterPlaceHolder.is_inbound === "true") ? (
              <Fragment>
                <Tag
                  className="filteredTagStyle"
                  closable={true}
                  onClose={ () =>
                    handleOnFilterElementChange("is_inbound", false)
                  }
                >
                  {I18n.t("order.filters.bonded_orders_label")}:{ " " }
                  {"Yes"}
                </Tag>
                &nbsp;&nbsp;
              </Fragment>
            ) : (
              ""
            )}

            { !isEmpty(filterPlaceHolder.tender_status) ? (
              <Fragment>
                <FilterTag
                  InternationalizationText={ I18n.t("agent_tenders.filter.tender_status") }
                  closable
                  onClose={ () => handleOnFilterElementChange("tender_status", "") }
                  filterValue={ filterPlaceHolder.tender_status }
                >
                  { I18n.t(`agent_tenders.filter.${filterPlaceHolder.tender_status}`) }
                </FilterTag>
                &nbsp;&nbsp;
              </Fragment>
            ) : (
              ""
            )}

            <Button data-testid="applied-filter-clear-button" type="link" className="button-2-large" onClick={ clearFilter }>
              { " " }
              Clear filters
            </Button>
          </Col>
        </Row>
        </div>
      }
    </Fragment>
  );
};

AppliedFilters.propTypes = {
  filter: PropTypes.string.isRequired,
  filterPlaceHolder: PropTypes.shape().isRequired,
  handleOnFilterElementChange: PropTypes.func.isRequired,
  currentWarehouse: PropTypes.shape().isRequired,
  currentAccount: PropTypes.shape().isRequired,
  handleOnOrderTokenClose: PropTypes.func.isRequired,
  clearFilter: PropTypes.func.isRequired,
  handleOnFilterChange: PropTypes.func.isRequired,
};

export default AppliedFilters;
